<template>
  <div>
    <Loading :loading="this.loading"></Loading>
  </div>
</template>

<script>
import inspection from '@/store/Api/inspection'
import profileApi from '@/store/Api/Common/profile'
import ssApi from '@/store/Api/Common/ss'
import modal from '@/assets/v3/modal'
import Loading from '@/views/v3/Loading.vue'
import { mapActions, mapGetters } from 'vuex'
import { useTsIdStore } from '@/store/tsId'
import { useSsInfoStore } from '@/store/ssInfo'
import { useProfileInfoStore } from '@/store/profileInfo'
import { useNativeDataStore } from '@/store/nativeData'
import { useVersionDataStore } from '@/store/versionData'

export default {
  data () {
    return {
      loading: true,
      profileInfo: [],
      ssInfo: []
    }
  },
  methods: {
    ...mapActions('INSPECTION', [
      'setInspection'
    ]),
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    setProfileInfo (profileInfo) {
      this.profileInfo = profileInfo
    },
    openErrorModal (message) {
      modal.alert(message)
    }
  },
  computed: {
    ...mapGetters('INSPECTION', [
      'inspection'
    ]),
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.tsid = this.$route.query.tsid
      getData.popinfoid = this.$route.query.popinfo_id
      getData.otoken = this.$route.query.otoken
      return getData
    },
    versionData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.appVersion = this.$route.query.x_cls_app_version ? this.$route.query.x_cls_app_version : '0.0.0'
      getData.platform = this.$route.query.x_cls_os ? this.$route.query.x_cls_os : 'iRidge'
      getData.osVersion = this.$route.query.x_cls_os_version ? this.$route.query.x_cls_os_version : '0.0'
      return getData
    }
  },
  async mounted () {
    console.log(location.href)
    // 戻るボタンの出し分け
    this.appDisplayBack(false)
    let isApiError = false

    // バージョン情報が一つでも未定義の場合はエラーダイアログを表示.
    if (this.isCLSAppVersionError(this.$route.query.x_cls_app_version, this.$route.query.x_cls_os, this.$route.query.x_cls_os_version)) {
      this.openErrorModal('アプリバージョンの認証でエラーが発生しました。')
      isApiError = true
      return
    } else {
      this.versionData.appVersion = this.versionData.appVersion ? this.versionData.appVersion : '0.0.0'
      this.versionData.platform = this.versionData.platform ? this.versionData.platform : 'iRidge'
      this.versionData.osVersion = this.versionData.osVersion ? this.versionData.osVersion : '0.0'
    }

    // profile情報マスタ取得。
    await profileApi.get(this.nativeData.tsid, this.nativeData.otoken, this.appVersionMakeRequestHeder(this.versionData)).then(res => {
      this.setProfileInfo(res.data.body)
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })
    // SS情報マスタ取得
    await ssApi.get(this.profileInfo.best_myss.code).then(res => {
      this.setSsInfo(res.data.body.ss_info)
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // inspection(予約)データ取得
    await inspection.get(this.nativeData.tsid).then(res => {
      this.setInspection(res.data)
    }).catch(e => {
      console.log('inspection-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    if (!isApiError) {
      if (this.inspection.inspections.length !== 0) {
        // ref: https://gitlab.ssl.iridge.jp/cosmo-oil/web-front/-/issues/165
        // コミっと車検が予約済みの場合は条件入力画面ではなく、カーケアトップに遷移する
        this.$router.push({
          name: 'CarCareTopV3',
          query: {
            popinfoid: this.$route.query.popinfo_id,
            tsid: this.$route.query.tsid,
            otoken: this.$route.query.otoken,
            x_cls_app_version: this.versionData.appVersion ? this.versionData.appVersion : '0.0.0',
            x_cls_os: this.versionData.platform ? this.versionData.platform : 'iRidge',
            x_cls_os_version: this.versionData.osVersion ? this.versionData.osVersion : '0.0'
          }
        })
      } else {
        // ref: https://gitlab.ssl.iridge.jp/cosmo-oil/web-front/-/issues/67
        // 車検対応/非対応SSに関わらず、車検証入力画面に遷移する
        const tsIdStore = useTsIdStore()
        tsIdStore.tsId = this.$route.query.tsid
        const ssInfoStore = useSsInfoStore()
        ssInfoStore.ssInfo = this.ssInfo
        const profileInfoStore = useProfileInfoStore()
        profileInfoStore.profileInfo = this.profileInfo
        const nativeDataStore = useNativeDataStore()
        nativeDataStore.nativeData = this.nativeData
        const versionDataStore = useVersionDataStore()
        versionDataStore.versionData = this.versionData
        this.$router.push({ name: 'CarV3' })
      }
    }
  },
  components: {
    Loading
  }
}

</script>
